import React from "react"
// import classNames from 'classnames'
import st from "./css/MenuItems.module.scss"
import { CDNBASE } from "../utils/maps"
// import Svg from './svg'

const MenuItems = ({ list, icon, iconSize = [122, 144], title, isMobile, styles, idPre = "" }) => {
  iconSize = isMobile ? iconSize[0] : iconSize[1];
  return (
    <div className={st.wrapper}>
      <h2>{title}</h2>
      <div
        className={st.itemsWrapper}
        style={{
          width: !isMobile
            ? `${(list.length / 7) * 100 + list.length * 5}%`
            : "100%",
          ...styles,
        }}
      >
        {list.map((v, i) => {
          return (
            <a key={v.id} href={`#${idPre}${v.id}`} className={st.item}>
              <div
                className={st.img}
                style={{
                  width: iconSize,
                  height: iconSize,
                  // backgroundImage: `url(${CDNBASE}/home/kuke_features/icons/${v.id}.png)`,
                  backgroundImage: `url(${CDNBASE}/home/${icon})`,
                  backgroundSize: "auto 100%",
                  backgroundPositionY: 0,
                  backgroundPositionX:  -(i * (iconSize - (isMobile ? 0.5 : 1))),
                }}
              ></div>
              <div className={st.name}>{v.name}</div>
            </a>
          )
        })}
      </div>
    </div>
  )
}

// MenuItems.propTypes = {
//   visible: PropTypes.bool,
//   onClose: PropTypes.func,
//   src: PropTypes.string,
// }

// MenuItems.defaultProps = {
//   visible: false,
//   onClose: () => { },
//   src: ``,
// }

export default MenuItems
